export default __webpack_public_path__ + "static/media/profile-image.a5a2129d.png";